import React from 'react';
import CreateGroup from './CreateGroup';

const EditGroup = props => <CreateGroup isEdit {...props} />;

export default EditGroup;
